import { VIDEO_CALL_PROVIDER_NAMES } from '@/constants/socket.ts';

export const formatMeetingData = (data: Record<string, any>) => {
	if (!data?.meeting) return null;

	const coach = data.meetingParticipantList?.find((participant: any) => participant.participantType === 'EXPERT');

	const student = data.meetingParticipantList?.find((participant: any) => participant.participantType === 'STUDENT');

	let token = data.meeting.token;
	if (data.meeting.videoCallProviderInfo?.name === VIDEO_CALL_PROVIDER_NAMES.IVS) {
		token = coach?.providerParticipantToken;
	}

	return {
		userInfos: {
			studentName: data.studentName,
			studentAvatar: data.studentAvatarLink,
			coachName: `${data.expertName} ${data.expertSurname}`,
			coachAvatar: data.expertAvatarLink,
			coachId: coach?.participantId,
			coachSubject: data.meeting.liveServiceGroup,
			studentId: student?.participantId
		},
		meetingType: data?.meeting?.meetingType,
		meetingId: data?.meeting?.id,
		streamId: coach?.providerParticipantId,
		roomId: data.meeting.roomId,
		token: token,
		socketURL: data.meeting.videoCallProviderInfo?.host,
		providerName: data.meeting.videoCallProviderInfo?.name,
		endDate: data.meeting.endDate,
		extensionNotificationDate: data.meeting.extensionNotificationDate || null,
		interactionId: data.meeting.interactionId,
		connectionApp: data?.meeting?.liveServiceGroup,
		meetingLastConnectionDate: data?.meeting?.meetingLastConnectionDate,
		meetingSubjectName: data?.meeting?.subjectName
	};
};
